// @flow

// import makeId from "../helpers/make-id.js";
import { getRandomLoadout } from "../Fixture_combatants.js";

export const attackList = [
  //Supers
  { actionId: "special_wildfire" },
  { actionId: "special_team-slice" },
  { actionId: "special_team-foreach" },
  { actionId: "special_team-revive" },
  { actionId: "special_team-clean" },
  { actionId: "special_commit" },
  { actionId: "special_revert" },
  { actionId: "special_sql-drop" },

  //Special
  { actionId: "special_thrash" },
  { actionId: "special_bug" },
  { actionId: "special_promise" },
  { actionId: "special_stash" },
  { actionId: "special_scrum" },
  { actionId: "special_firewall" },
  { actionId: "special_foreach" },
  { actionId: "special_slice" },
  { actionId: "special_garbage-jammer" },
  { actionId: "special_ddos" },
  { actionId: "special_copy-paste" },
  { actionId: "special_curl" },
  { actionId: "special_curl-mk2" },
  { actionId: "special_sql-injection" },
  { actionId: "special_clean" },
  { actionId: "special_headphones" },
  { actionId: "special_deadline" },
  { actionId: "special_scope-bomb" },
  { actionId: "special_troll" },
  { actionId: "special_screen-crack" }
];

export function getPlayerLoadout() {
  return {
    ...getRandomLoadout()

    //User overrides (for dev)

    //status: "lag",
    //hp: 0,
    // pp: 35,
    //status: "memory-leak",
    // attacks: [
    //   ...attackList
    // ],
    // items: [
    //   {
    //     actionId: "item_mini-pp-pack",
    //     instanceId: makeId("itemInstance", 10),
    //     isStolen: false
    //   },
    // ]
  };
}



// WEBPACK FOOTER //
// ./src/battle/PlayerFixture_combatant.js